import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../../shared/shared.module';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { WaitPasswordComponent } from './components/wait-password/wait-password.component';
import { ForgotPasswordPageComponent } from './containers/forgot-password-page.component';

import { ResetPasswordPageComponent } from './containers/reset-password-page.component';
import { WaitPasswordPageComponent } from './containers/wait-password-page.component';

import { ForgotPasswordEffects } from './effects/forgot-password';
import { reducers } from './reducers';
import { ConfirmPasswordPageComponent } from './containers/confirm-password-page.component';
import { ConfirmPasswordComponent } from './components/confirm-password/confirm-password.component';
import { HasForgotPasswordGuard } from './guards/has-forgot-password.guard';
import { HasCodeGuard } from './guards/has-code.guard';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    StoreModule.forFeature('forgot-password', reducers),
    EffectsModule.forFeature([ForgotPasswordEffects]),
  ],
  declarations: [
    ResetPasswordPageComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    ForgotPasswordPageComponent,
    WaitPasswordComponent,
    WaitPasswordPageComponent,
    ConfirmPasswordPageComponent,
    ConfirmPasswordComponent,
  ],
  providers: [
    HasForgotPasswordGuard,
    HasCodeGuard,
  ]
})
export class ForgotPasswordModule {
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/forgot-password.module.ts